  import React, { useEffect } from 'react';
  import "./IotSolution.css";
  import { useNavigate } from "react-router-dom"; // Import useNavigate
  import bg2 from '../../../assets/Centralized/BG_2.png'
  import ems from '../../../assets/Centralized/mini-card-iot/1_EMS.png'
  import bms from '../../../assets/Centralized/mini-card-iot/2_Billing.png'
  import AQI from '../../../assets/Centralized/mini-card-iot/3_AQI.png'
  import fire from '../../../assets/Centralized/mini-card-iot/4_Fire.png'
  import AIC from '../../../assets/Centralized/mini-card-iot/5_AC.png'
  import weste from '../../../assets/Centralized/mini-card-iot/6_Wastewater.png'
  import rectifier from '../../../assets/Centralized/mini-card-iot/7_Rectifier.png'
  import oee from '../../../assets/Centralized/mini-card-iot/8_OEE.png'
  import Solar from '../../../assets/Centralized/mini-card-iot/9_Solar.png'
  import Vehicle from '../../../assets/Centralized/mini-card-iot/10_Vehicle.png'
  import Smart from '../../../assets/Centralized/mini-card-iot/11_Smart meeting.png'
  import carbon from '../../../assets/Centralized/mini-card-iot/12_Carbon.png'
  function IotSolution() {
    const navigate = useNavigate();

    useEffect(() => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
  
      // Optionally, add an event listener for navigation changes
      const handleScroll = () => {
        const currentHash = window.location.hash;
        const element = document.querySelector(currentHash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      };
  
      window.addEventListener('hashchange', handleScroll);
      return () => {
        window.removeEventListener('hashchange', handleScroll);
      };
    }, []);
    const emsClick = () => {
      navigate("/ems"); // Navigate to the EMS page
    };

    const bmsClick = () => {
      navigate("/bms"); // Navigate to the EMS page
    };

    const airQualityClick = () => {
      navigate("/aqi"); // Navigate to the EMS page
    };

    const fireAlarmclick = () => {
      navigate("/fire-alarm"); // Navigate to the EMS page
    };

    const acOptimizedclick = () => {
      navigate("/ac-optimized"); // Navigate to the EMS page
    };

    const wasteWaterclick = () => {
      navigate("/wastewater"); // Navigate to the EMS page
    };
    
    const rectifierclick = () => {
      navigate("/rectifier"); // Navigate to the EMS page
    };

    const oeeclick = () => {
      navigate("/oee"); // Navigate to the EMS page
    };

    const solarplantclick = () => {
      navigate("/solarplant"); // Navigate to the EMS page
    };
    
    const vehicletrackingclick = () => {
      navigate("/vehicletracking"); // Navigate to the EMS page
    };

    const smartMeetngclick = () => {
      navigate("/smartmeeting"); // Navigate to the EMS page
    };
    
    const carbonFootprintclick = () => {
      navigate("/carbonfootprint"); // Navigate to the EMS page
    };

    
    
    return (
      <div>
        <div className="iot-solutions-image">
          <div className="iot-solutions-content">
            <div className="iot-solutions-text">
              <div className="iot-solutions-header">Centralized PLATFORM</div>
              <div className="iot-solutions-sub">
                Norem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                vulputate libero et velit interdum, ac aliquet odio mattis. Class
                aptent taciti sociosqu ad litora torquent per conubia nostra, per
                inceptos himenaeos.
              </div>
              <div className="iot-solution-button">
                <a href="/" className="read-more-btn-1">
                  Read More
                </a>
                <a href="/" className="read-more-btn-2">
                  Read More
                </a>
              </div>
            </div>
          </div>
          <div className="blur-shadow"></div>
        </div>
        <div className="iot-solutions-for-faster">
          <img
            src={bg2}
            alt=""
            className="image-iot"
          />
          <div id="#iot-blog" className="sub-text-for-faster">
            <div className="iot-solutions-for-faster-h1">IoT Solutions</div>
            <div className="iot-solutions-for-faster-h2">
              For faster cloud digital transformation
            </div>
            <div className="iot-solutions-for-faster-h3">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
              turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus
              nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum
              tellus elit sed risus. Maecenas eget condimentum velit, sit amet
              feugiat lectus. Class aptent taciti sociosqu ad litora torquent per
              conubia nostra, per inceptos himenaeos. Praesent auctor purus luctus
              enim egestas, ac scelerisque ante pulvinar.
            </div>
          </div>
        </div>
        <div className="iot-solutions-list">
          <div className="iot-solutions-list-header">IoT Solutions</div>
          <div className="iot-solutions-list-content">
            <div className="sub-carf-content-iot-solutions" onClick={emsClick}>
              <img
                src={ems}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    Energy Management System (EMS)
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate libero et velit interdum, ac aliquet odio mattis.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-carf-content-iot-solutions" onClick={bmsClick}>
              <img
                src={bms}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    Billing Management System (BMS)
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate libero et velit interdum, ac aliquet odio mattis.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="iot-solutions-list-content" >
            <div className="sub-carf-content-iot-solutions" onClick={airQualityClick}>
              <img
                src={AQI}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    Air Quality Management Platform (AQI)
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate.
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-carf-content-iot-solutions" onClick={fireAlarmclick}>
              <img
                src={fire}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    Fire Alarm Management Platform
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate libero et velit interdum, ac aliquet odio mattis.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="iot-solutions-list-content">
            <div className="sub-carf-content-iot-solutions" onClick={acOptimizedclick}>
              <img
                src={AIC}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    A/C Optimized Platform
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate libero et velit interdum, ac aliquet odio mattis.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-carf-content-iot-solutions" onClick={wasteWaterclick}>
              <img
                src={weste}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    Wastewater Treatment Platform
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate libero et velit interdum, ac aliquet odio mattis.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="iot-solutions-list-content">
            <div className="sub-carf-content-iot-solutions" onClick={rectifierclick}>
              <img
                src={rectifier}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    Rectifier Management System
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate libero et velit interdum, ac aliquet odio mattis.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-carf-content-iot-solutions" onClick={oeeclick}>
              <img
                src={oee}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    OEE Platform
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate libero et velit interdum, ac aliquet odio mattis.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="iot-solutions-list-content">
            <div className="sub-carf-content-iot-solutions" onClick={solarplantclick}>
              <img
                src={Solar}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    Solar Plant Management
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate libero et velit interdum, ac aliquet odio mattis.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-carf-content-iot-solutions" onClick={vehicletrackingclick}>
              <img
                src={Vehicle}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    Vehicle Tracking Management
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate libero et velit interdum, ac aliquet odio mattis.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="iot-solutions-list-content">
            <div className="sub-carf-content-iot-solutions" onClick={smartMeetngclick}>
              <img
                src={Smart}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    Smart Meeting Room
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate libero et velit interdum, ac aliquet odio mattis.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-carf-content-iot-solutions" onClick={carbonFootprintclick}>
              <img
                src={carbon}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    Carbon Footprint Platform (CFO)
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                    vulputate libero et velit interdum, ac aliquet odio mattis.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  export default IotSolution;
